import { PatientInfoValues } from '../enums/patient-info-values.enum';

export const PatientInfoValueLabel = {
  [PatientInfoValues.SPECIES]: 'Species',
  [PatientInfoValues.BREED]: 'Breed',
  [PatientInfoValues.WEIGHT]: 'Weight',
  [PatientInfoValues.BIRTH_DATE]: 'Age',
  [PatientInfoValues.GENDER]: 'Gender',
  [PatientInfoValues.OWNER_NAME]: 'Owner name',
  [PatientInfoValues.OWNER_EMAIL]: 'Owner email',
  [PatientInfoValues.OWNER_PHONE_NUMBER]: 'Owner phone number'
};
